export default function () {
  const targetElement = document.getElementById('wc-nav-container');

  if (!targetElement) {
    return;
  }

  function handleScroll() {
    const scrollPosition = window.scrollY;

    targetElement.classList.toggle('scrolled-down', scrollPosition > 100);
  }

  function debounce(func, wait, ...args) {
    let timeout;
    return function () {
      const context = this;

      const later = function () {
        timeout = null;
        func.apply(context, args);
      };

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  handleScroll();
  window.addEventListener('scroll', debounce(handleScroll, 50));
}
